import { render } from "./SideProjects.vue?vue&type=template&id=96214f94"
import script from "./SideProjects.vue?vue&type=script&lang=js"
export * from "./SideProjects.vue?vue&type=script&lang=js"

import "./SideProjects.vue?vue&type=style&index=0&id=96214f94&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__